import { useDebounce } from 'fitify-ui/src/hooks/useDebounce'
import { useDeviceOSDetect } from 'fitify-ui-onboarding/src/hooks/useDeviceOSDetect'
import { useKeyboardInsetV2 } from 'fitify-ui-onboarding/src/hooks/useKeyboardInsetV2'
import { type PropsWithChildren, useLayoutEffect } from 'react'

import { FORM_ID } from 'components/GenderFunnel/Layout/Layout.Utils'

import { StyledContainer } from './BottomContent.Styled'

const FOCUSED_INPUT_DEBOUNCE_MS = 50
const SCROLL_INTO_VIEW_TIMEOUT_MS = 50

export const BottomContent = ({ children }: PropsWithChildren) => {
  const { bottomInset, focusedInputUuid } = useKeyboardInsetV2()
  const { isIOS, isAndroid, isDetermined } = useDeviceOSDetect()

  // Debounce time to wait for the focused input to stabilize with multiple inputs
  const debouncedFocusedInputUuid = useDebounce(
    focusedInputUuid,
    FOCUSED_INPUT_DEBOUNCE_MS
  )

  // Scroll the form into view when an input is focused on mobile devices
  useLayoutEffect(() => {
    const visualViewport = window.visualViewport
    const formElement = document.getElementById(FORM_ID)
    const isMobile = isDetermined && (isIOS || isAndroid)
    if (
      debouncedFocusedInputUuid &&
      visualViewport &&
      formElement &&
      isMobile
    ) {
      // Short timeout to ensure the scroll event would be fired on iOS
      const timeout = setTimeout(() => {
        formElement.scrollIntoView({ behavior: 'smooth' })
      }, SCROLL_INTO_VIEW_TIMEOUT_MS)
      return () => clearTimeout(timeout)
    }
  }, [debouncedFocusedInputUuid, isDetermined, isIOS, isAndroid])

  return (
    <StyledContainer $hasInset={bottomInset > 0} $bottomInset={bottomInset}>
      {children}
    </StyledContainer>
  )
}
